import { t as e } from "./cx-BjmrJCen.js";
/* empty css                              */
import { jsx as t } from "react/jsx-runtime";
//#region src/components/button/button.css.ts
var n = {
	primary: "wvrslc1 wvrslc0",
	ghost: "wvrslc2 wvrslc0",
	dangerGhost: "wvrslc3 wvrslc0"
};
//#endregion
//#region src/components/button/button.tsx
function r({ block: r = !1, children: i, className: a, size: o = "default", tone: s = "default", variant: c = "primary", ...l }) {
	let u = c === "ghost" && s === "danger" ? n.dangerGhost : c === "ghost" ? n.ghost : n.primary;
	return /* @__PURE__ */ t("button", {
		...l,
		className: e(u, o === "subtle" && "wvrslc4", r && "wvrslc5", a),
		children: i
	});
}
//#endregion
export { r as Button };

//# sourceMappingURL=button.js.map